<template>
  <v-content v-if="sizeW" @click="alert('aaa')">
    <background v-if="!selectedMenu"/>
    <table
      class="table-main"
      cellspacing="0"
      style="z-index:102;"
      :style="{ 'background-color': BGColor }"
    >
      <tr>
        <td
          class="simulation"
          :style="{ 'background-color': BGColor,
                    width: `${menuWidth}px !important`
                  }"
        >
          <div class="simulation-content"
            :style="{ 'background-color': BGColor }"
               >
          <!--a @click="handleMenuClick(null)" -->
          <a @click="handleReload" >
            <v-img
              v-if="logo && (!touchPublic || forceIMG)"
              :src="Logo"
              width="`${menuWidth}px`"
              heigth="auto"
              alt="logo"
              style="margin-bottom: 30px;"
            />
            <screensaver />
          </a>
          <div class="text-center"
            :style="{ 'margin-right': allergenFilters ? '-20px' : '0'}"
          >          
            <custom-auth 
              :type="authType"
            />
          </div>
          <dish-orders-cart
            v-if="config"
            :config="config"
            :locale="locale"
          />

          <custom-menu
            v-if="menus"
            :allergenFilters="allergenFilters"
            :data="isSimulation ? menus : menus.filter(x => x.IsActive && !x.HideDesktop && x.Availability.status.date && x.Availability.status.time)"
            :onMenuChange="handleMenuClick"
            style="right: 0px; max-width:360px !important;"
          />
          <br />
            <back-button :isMain="true" :isMenu="true" v-if="!isSimulation"/>
            <custom-URL-back :isMain="true" :isMenu="true" v-if="!isSimulation"/>
          <br/>
            <center style="color: #FFFFFF33;">{{info}}</center>
          <br/>
          </div>
        </td>
        <td id="mainForm" v-resize="onResize">
          <custom-language 
            v-if="!selectedMenu && !dtouchIsTouchPublic"
            style="right:0px;position: absolute;z-index:100;"
            :style="{ 'width' : `${sizeW}px`}"
          />
          <custom-content
            v-if="selectedMenu"
            :menu="selectedMenu"
          />
          <div
            v-else
            :style="{ 'width' : `${sizeW}px`}"
          />
        </td>
      </tr>
    </table>
    <v-btn
      id="btnBackToTop"
      color="rgba(0, 0, 0, 0.3)"
      fixed
      fab
      dark
      bottom
      right
      @click.stop.prevent="handleBackToTop"
    >
      <v-icon>mdi-arrow-up-bold</v-icon>
    </v-btn>
    <v-btn
      v-if="isPI"
      color="rgba(0, 0, 0, 0.3)"
      fixed
      fab
      dark
      top
      right
      small
      @click.stop.prevent="handleRefresh"
      style="z-index:112"
    >
      <v-icon>mdi-reload</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
  window.onscroll = function () { scrollFunction() }
  function scrollFunction () {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      if (document.getElementById('btnBackToTop')) document.getElementById('btnBackToTop').style.display = 'block'
    } else {
      if (document.getElementById('btnBackToTop')) document.getElementById('btnBackToTop').style.display = 'none'
    }
  }

  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import constants from '@/constants'
  import CustomAuth from '@/components/customAuth/Index'

  import CustomMenu from './menu/Index'
  import CustomContent from './content/Index'
  import Background from './Background'
  import BackButton from '@/components/BackButton'
  import CustomURLBack from '@/components/CustomURLBack'
  import DishOrdersCart from '@/views/private/dishOrders/dishOrdersCart/Index'

  import CustomLanguage from '../mobile/CustomLanguage'
  import Screensaver from './screensaver/Index'
  export default {
    components: {
      Background,
      CustomMenu,
      CustomContent,
      CustomLanguage,
      CustomAuth,
      BackButton,
      CustomURLBack,
      DishOrdersCart,
      Screensaver,
    },
    props: {
      domain: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      selectedMenu: null,
      logo: null,
      allergenFilters: null,
      touchPublic: false,
      menuWidth: 360,
      sizeW: null,
      config: null,
      expandFirstElementWithoutMainMenu: false,
      expandFirstElement: false,
    }),
    computed: {
      ...mapState('app',['authData', 'authType', 'BGColor', 'Color', 'Logo', 'menus','BGColorContent', 'dtouchIsTouchPublic', 'locale']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      back () {
        return this.$route.query.back ? this.$route.query.back : null 
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      info () {
        return process.env.VUE_APP_INFOSORT
      },
      /*sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },*/
      forceIMG () {
         return this.$route.query.forceIMG ? true : false
      },
    },
     watch: {
      Logo: {
        handler: function (newValue) {
          this.logo = newValue
        },
        deep: true
      },
      'authData' () {
        this.getMenus()
      },
       dtouchIsTouchPublic () {
         this.prepareTouchPublic()
       },
    },
    mounted () {
      this.prepareTouchPublic()
      if (!utils.isMobile()) {
        // console.log(this.BGColorContent)
        document.getElementById('app').style.backgroundColor = this.BGColorContent
        // document.body.style.backgroundColor = "red"//this.BGColorContent + 'FF'
      }
      this.getEnterprise()
      this.getMenus()
    },
    methods: {
      handleSetStats (menu) {
        // añadimos los registros de accesos públicos
        api.setStats('stats', menu)
          .then(response => {
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      prepareTouchPublic () {
        this.touchPublic = this.dtouchIsTouchPublic
        this.menuWidth = 360//this.touchPublic ? 360 : 400
        this.sizeW = window.innerWidth - (!utils.isMobile() ? this.menuWidth : 0)
      },
      onResize () {
        const aux = document.body.offsetWidth - this.menuWidth
        /*console.log('jhm', aux)
        document.getElementById('mainForm').style.maxWidth = `${aux}px !important`// window.innerWidth
        this.$store.state.app.mainFormWidth = document.getElementById('mainForm').offsetWidth // window.innerWidth
        */
        this.$store.state.app.mainFormWidth = aux
      },    
      getEnterprise () {
        const auxID = this.ID ? this.ID : this.domain
        if (auxID) {
          const aux = this.$route.query.c ? `?public=true&c=${this.$route.query.c}` : !this.isSimulation ? '?public=true' : ''
          api.getItem('enterprises', false, auxID.concat(aux)).then(response => {
            this.config = response
            if (!response.ID) {
              // TODO pendiente hacer la validación
              // si es privat
              this.$router.push('/404')
              // window.location.href = '/#/404'
            }
            if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone
            this.$store.state.app.dtouchWorkspace = response.ID
            this.handleSetStats(null)
            this.allergenFilters = response.AllergenFilters
            this.$store.state.app.allergenFilters = response.AllergenFilters
            this.$store.state.app.showDishesImage = response.ShowDishesImage
            this.$store.state.app.showDishesAllergens = response.ShowDishesAllergens
            this.expandFirstElementWithoutMainMenu = response.ExpandFirstElementWithoutMainMenu ? true : false
            this.expandFirstElement = response.ExpandFirstElement ? true : false
            
            if (!this.isSimulation) document.title = response.Name // se añade esto para que en el title aparezca el nombre del cliente
            if (this.isCommonMenus){
              this.$store.state.app.enterpriseName = 'Menús comunes'
              this.$store.state.app.BGColor = '#56A099'

              this.$store.state.app.BGColorSecundary = '#CCCCCC'
              this.$store.state.app.BGColorContent = '#FFFFFF'
              this.$store.state.app.Color = '#FFFFFF'
              this.$store.state.app.ColorSecundary = '#495057'
              this.$store.state.app.ColorContent = '#495057'
              this.$store.state.app.Logo = 'http://dtouch.es/assets/logo_menuscomunes.png'
              this.$store.state.app.Carousel = []
              this.$store.state.app.withGradient = false
              this.$store.state.app.withLine = false

            } else {
              this.$store.state.app.enterpriseName = response.Name
              this.$store.state.app.BGColor = response.BGColor ? response.BGColor : '#56A099'
              this.$store.state.app.btnBackgroundColor = response.BtnBackgroundColor ? response.BtnBackgroundColor : ''
              this.$store.state.app.btnTextColor = response.BtnTextColor ? response.BtnTextColor : ''
              this.$store.state.app.foodDrinkTextColor = response.FoodDrinkTextColor ? response.FoodDrinkTextColor : ''
              this.$store.state.app.foodDrinkBGColor = response.FoodDrinkBGColor ? response.FoodDrinkBGColor : ''
              this.$store.state.app.foodIconRight = response.FoodIconRight
      
              this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
              this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
              this.$store.state.app.Color = response.Color ? response.Color : '#495057'
              this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
              this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
              this.logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png';
              this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
              this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
              this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
              this.$store.state.app.withGradientSubmenu = response.GradientSubmenu === 1 ? true : false
              this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

              this.$store.state.app.GlobalFont = response.GlobalFont
              if (response.Font) this.$store.state.app.Font = response.Font
              if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
              if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

              if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
              if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
              if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent

              if (response.TextFormat) this.$store.state.app.TextFormat = response.TextFormat
              if (response.TextFormatSecundary) this.$store.state.app.TextFormatSecundary = response.TextFormatSecundary
            }
            //             
            // this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
            // this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
            // this.$store.state.app.Color = response.Color ? response.Color : '#495057'
            // this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
            // this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
            // this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
            // this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
            // this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
            // this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

            // this.$store.state.app.GlobalFont = response.GlobalFont
            // if (response.Font) this.$store.state.app.Font = response.Font
            // if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
            // if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

            // if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
            // if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
            // if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent       
            if (response.AuthType) this.$store.state.app.dfileWorkspace = response.DfileWorkspace
                 
            this.$store.state.app.Languages = response.Languages ? response.Languages.split(',') : ['es']
            this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
            this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'
            this.loadingEnterprise = false
          })
        } else {
          this.$router.push('/404')
        }
      },
      getMenus () {
        if (this.isMenu || !this.isSimulation) {
          const auxID = this.isCommonMenus ? '0000' : this.ID ? this.ID : this.domain
          if (auxID) {
            api.getAll(`menus`, false, null, null, null, auxID).then(response => {
              if (this.dtouchIsTouchPublic) response = response.filter(x => !x.HideTotem)
              response = response.map (item => {
                if (item.Menus) {
                  item.Menus = item.Menus.map(submenu => {
                    submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                    if (submenu.Common && submenu.Availability.status) {
                      const {date, time} = submenu.Availability.status
                        submenu.IsActive = date && time ? true : false
                    }
                    return submenu
                  })
                  item.Menus = item.Menus.filter(x => x.Availability.status.time && x.Availability.status.date)
                }
                item.Availability = utils.checkAvailabilityStatus(item.Availability)
                if (item.Common && item.Availability.status) {
                  const {date, time} = item.Availability.status
                    item.IsActive = date && time ? true : false
                }
                return item
              })
              // this.$store.state.app.menus = response
              if (this.$store.state.app.authType !== 'none' && !this.$store.state.app.authData) {
                // this.$store.state.app.menus = response.filter(x => !x.Private && x.IsActive)
                this.$store.state.app.menus = response.filter(x => !x.Private && x.Availability && x.Availability.status.time && x.Availability.status.date)
              } else {
                this.$store.state.app.menus = response
              } 
              if (this.expandFirstElement && this.$store.state.app.menus.length > 0) this.handleMenuClick (this.$store.state.app.menus[0]) 
            })
            // this.$store.state.app.menus = []
          } else {
            this.$router.push('/404')
          }
        } else {
          this.$store.state.app.menus = [
            {
              ID: '1',
              Name: { es: 'Menú 1', en: 'Menu 1' },
              IsActive: true,
              Common: 0,
              Menus: [
                {
                  ID: '3',
                  Name: { es: 'Submenú 1', en: 'Submenu 1' },
                  IsActive: true,
                  Type: 0,
                  Common: 0,
                }
              ]
            },
            {
              ID: '2',
              Name: { es: 'Menú 2', en: 'Menu 2' },
              IsActive: true,
              Type: 0,
              Common: 0,
            }
          ]
        }
      },
      handleBackToTop () {
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      },
      handleRefresh () {
        this.getMenus()
        if (this.selectedMenu.ID) {
          const aux = JSON.parse(JSON.stringify(this.selectedMenu))
          this.selectedMenu = null
          this.selectedMenu = aux
          // const id = this.selectedMenu.ID
          // console.log('aux', id)
          // api.getAll(`contents`, false, null, null, null, id).then(response => {
          //   this.$store.state.app.contents = response
          // })
        }
      },
      handleMenuClick (menu) {      	
        // if (!menu && this.isPI) {
        //   // this.$router.push('/#/?PI=true')
        //   window.location.href = '/#/?PI=true'
        //   location.reload()
        // }
        // INI utilizado para la parrilla y que no se reproduzca cuando no esté activo el menu
        if (menu && !this.isPI) this.$store.state.app.expandMenuID = menu.ID
        // END utilizado para la parrilla y que no se reproduzca cuando no esté activo el menu
        if (!menu) window.location.href = '/#/?'.concat(`&locale=${this.locale}`, this.touchPublic ? '&touchPublic=true' : '', this.isPI ? '&PI=true' : '', this.back ? `&back=${this.back}` : '', this.forceIMG ? '&forceIMG=true' : '')
        this.selectedMenu = menu
      },
      handleReload () {
        location.reload()
      },
    }
  }
</script>
<style lang="scss">
#mainForm {
}
  h1 {
    font-weight: normal;
  }
  .table-main {
    width: 100%;
    min-height: calc(100vh);
    z-index: 110;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }

  .simulation::-webkit-scrollbar { 
    width: 0 !important;
    display: none; 
  }
  .simulation {
    width: 360px;
    padding: 0;
  }
  .simulation-content {
    position:fixed;
    width: 360px;
    padding: 0;
    /* overflow: hidden; */
    max-height: 100vh;
  }
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; 
  } 
  /* Hide scrollbar for Chrome, Safari and Opera */
  .simulation-content::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .simulation-content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  } 
</style>
